/**
 * Suggested kryspace folder slug from a company display name (GGCC / Claude alignment).
 * Operators may rename; this is a hint stored on chat thread metadata for traceability.
 */
export function kryspaceCompanySlugHint(companyName: string): string {
  const s = companyName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return s.length > 0 ? s : 'company';
}
